import { render } from "./NcrmPrivacyBreakdownCard.vue?vue&type=template&id=3feb6421&scoped=true"
import script from "./NcrmPrivacyBreakdownCard.vue?vue&type=script&lang=js"
export * from "./NcrmPrivacyBreakdownCard.vue?vue&type=script&lang=js"

import "./NcrmPrivacyBreakdownCard.vue?vue&type=style&index=0&id=3feb6421&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3feb6421"]])

export default __exports__